import { Link } from 'react-router-dom';

import { START_ACTION } from '../reducers/actionReducer';
import Button from './inputs/Button';

export default function FileSelection({
  image,
  prompt,
  UploadComponent,
  uploadComponentParams = {},
  uploadActionLabel,
  selectButtonTo,
  selectButtonLabel,
  dispatchAction,
}) {
  return (
    <div className="w-full h-full flex flex-col overflow-hidden justify-center items-center gap-2">
      <div className="flex items-center">
        <img className="h-80" src={image} alt="" />
      </div>
      <h4>{prompt}</h4>
      <div className="flex space-x-3 mb-24">
        <Button
          type="button"
          primary
          onClick={() =>
            dispatchAction({
              type: START_ACTION,
              payload: {
                name: uploadActionLabel,
                component: (
                  <UploadComponent
                    dispatchAction={dispatchAction}
                    {...uploadComponentParams}
                  />
                ),
              },
            })
          }
        >
          Add a New File
        </Button>
        <Link to={selectButtonTo}>
          <Button type="button" secondary>
            {selectButtonLabel}
          </Button>
        </Link>
      </div>
    </div>
  );
}
